import {
    LoaderCircle
} from "lucide-react";

export default function Button({

    children,

    variant = "primary",

    size = "md",

    icon,

    loading = false,

    fullWidth = false,

    className = "",

    ...props

}){

    return(

        <button

            className={

                `
                crm-btn
                crm-btn-${variant}
                crm-btn-${size}
                ${fullWidth ? "crm-btn-block" : ""}
                ${loading ? "crm-btn-loading" : ""}
                ${className}
                `

            }

            disabled={

                loading ||

                props.disabled

            }

            {...props}

        >

            {

                loading

                ?

                <LoaderCircle

                    size={16}

                    className="crm-btn-spinner"

                />

                :

                icon

            }

            {

                children &&

                <span>

                    {children}

                </span>

            }

<style>{`

.crm-btn{

    display:inline-flex;

    align-items:center;

    justify-content:center;

    gap:10px;

    height:42px;

    padding:0 18px;

    border:none;

    border-radius:12px;

    cursor:pointer;

    font-size:14px;

    font-weight:600;

    transition:all .18s ease;

    white-space:nowrap;

}

.crm-btn:disabled{

    opacity:.6;

    cursor:not-allowed;

}

/* Primary */

.crm-btn-primary{

    background:#2563EB;

    color:#FFF;

}

.crm-btn-primary:hover:not(:disabled){

    background:#1D4ED8;

}

/* Secondary */

.crm-btn-secondary{

    background:#F8FAFC;

    border:1px solid #E5E7EB;

    color:#334155;

}

.crm-btn-secondary:hover:not(:disabled){

    background:#EEF2FF;

}

/* Success */

.crm-btn-success{

    background:#16A34A;

    color:#FFF;

}

/* Danger */

.crm-btn-danger{

    background:#DC2626;

    color:#FFF;

}

/* Ghost */

.crm-btn-ghost{

    background:transparent;

    color:#475569;

}

.crm-btn-ghost:hover{

    background:#F1F5F9;

}

/* Outline */

.crm-btn-outline{

    background:#FFF;

    border:1px solid #CBD5E1;

    color:#334155;

}

.crm-btn-outline:hover{

    border-color:#2563EB;

    color:#2563EB;

}

/* Sizes */

.crm-btn-sm{

    height:34px;

    padding:0 12px;

    font-size:13px;

}

.crm-btn-md{

    height:42px;

    padding:0 18px;

}

.crm-btn-lg{

    height:48px;

    padding:0 22px;

    font-size:15px;

}

.crm-btn-block{

    width:100%;

}

.crm-btn-spinner{

    animation:spin .8s linear infinite;

}

@keyframes spin{

    to{

        transform:rotate(360deg);

    }

}

`}</style>

        </button>

    );

}